










import ClipboardIcon from '@/components/atoms/ClipboardIcon.vue'
import ForgotPasswordImageLink from '@spa/components/pages/auth/signup/shared/forgot-password/ImageLink.vue'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component({
  components: {
    ForgotPasswordIconLink: ForgotPasswordImageLink,
    ClipboardIcon,
  },
})
export default class DefaultForgotPassword extends Vue {
}
